import React from 'react';
import styles from './spoiler.module.scss';
import { AppContext } from '../../App';
import { getTrans } from '../../Utils/translate';

const Spoiler = ({ onClick }) => {
  const context = React.useContext(AppContext);
  const { warning, message, spoilerButtonName } = context.lang;

  return (
    <div className={styles.spoilerSection}>
      <div>
        <span className={styles.spoilerWarningFontSize}>{getTrans(warning)}</span>
      </div>
      <div className={styles.marginT}>
        <span className="text-white">{getTrans(message)}</span>
      </div>
      <button className={styles.continueButton} onClick={onClick}>
        {getTrans(spoilerButtonName)}
      </button>
    </div>
  );
};

export { Spoiler };
